import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/pages/Home.vue'),
        meta: { layout: MainLayout, titleKey: 'meta.siteName' },
    },
    {
        path: '/hardware',
        name: 'hardware',
        component: () => import('@/pages/Hardware.vue'),
        meta: { layout: MainLayout, titleKey: 'hardware.title' },
    },
    {
        path: '/impressum',
        name: 'imprint',
        component: () => import('@/pages/Impressum.vue'),
        meta: { layout: MainLayout, titleKey: 'legal.imprint.title' },
    },
    {
        path: '/datenschutz',
        name: 'privacy',
        component: () => import('@/pages/Datenschutz.vue'),
        meta: { layout: MainLayout, titleKey: 'legal.privacy.title' },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/pages/NotFound.vue'),
        meta: { layout: MainLayout, titleKey: 'notFound.title' },
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        if (to.hash) {
            return { el: to.hash, behavior: 'smooth', top: 80 }
        }
        return { top: 0, behavior: 'smooth' }
    },
})

export default router
